import * as tracking from 'dibs-tracking';

function trackSocialMediaShare(label) {
    tracking.trackEvent({
        action: 'product from PDP',
        label,
        category: 'share',
        eventName: tracking.eventNameConstants.EVENT_SHARE,
        step_interaction_name: tracking.stepInteractionConstants.STEP_INTERACTION_PRODUCT_FROM_PDP,
        method: label,
    });
}

export function trackPinterestClick(itemTitle) {
    tracking.trackSocial({
        name: 'pinterest',
        opt_target: itemTitle, // eslint-disable-line camelcase
        socialAction: 'share',
    });
    trackSocialMediaShare(tracking.methodTypeConstants.METHOD_TYPE_PINTEREST);
}

export function trackFacebookClick(itemTitle) {
    tracking.trackSocial({
        name: 'facebook',
        opt_target: itemTitle, // eslint-disable-line camelcase
        socialAction: 'share intent',
    });
    trackSocialMediaShare(tracking.methodTypeConstants.METHOD_TYPE_FACEBOOK);
}

export function trackEmailClick(itemId) {
    tracking.trackEvent({
        category: 'email a friend',
        action: 'email a friend initiated',
        label: `item|${itemId}`,
    });
}

function trackPrintClick(withOrWithout) {
    tracking.trackEvent({
        category: 'product',
        action: 'print item',
        label: `print ${withOrWithout} price from pdp`,
    });
}
export function trackPrintWithPriceClick() {
    trackPrintClick('with');
}

export function trackPrintNoPriceClick() {
    trackPrintClick('without');
}
